export enum TraitBuildStage {
    SELECT_TRAIT,
    SELECT_STRENGTH,
    SELECT_TARGETS,
    EXTRA_VALUES,
}
